module.exports = __webpack_public_path__ + "static/media/szkloPin.cce09e81.png";